import { gql } from "@apollo/client";

const REMOVE_SPONSOR = gql`
  mutation removeSponsor($id: Int!) {
    removeSponsor(id: $id) {
      id
    }
  }
`;

export default REMOVE_SPONSOR;
